(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* Header scroll */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile menu */
  const mobileMenu = $('.mobile-menu');
  const menuToggle = $('.menu-toggle');
  const menuClose = $('.mobile-menu__close');
  const openMenu = () => {
    mobileMenu?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeMenu = () => {
    mobileMenu?.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  menuToggle?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  $('.mobile-menu__overlay')?.addEventListener('click', closeMenu);
  $$('.mobile-menu [data-cart-open]').forEach((el) =>
    el.addEventListener('click', () => { closeMenu(); openCart(); })
  );

  /* Announcement rotator (mobile) */
  const rotator = $('.announcement-bar__rotator');
  if (rotator) {
    const items = $$('.announcement-bar__item');
    if (items.length > 1) {
      let idx = 0;
      const show = (i) => {
        rotator.innerHTML = '';
        rotator.appendChild(items[i].cloneNode(true));
      };
      show(0);
      setInterval(() => { idx = (idx + 1) % items.length; show(idx); }, 3500);
    }
  }

  /* Cart drawer */
  const cartDrawer = $('.cart-drawer');
  const cartBody = $('.cart-drawer__body');
  const cartCountEls = $$('[data-cart-count]');
  const cartFooter = $('.cart-drawer__footer');
  const cartEmpty = $('.cart-drawer__empty');

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' lei';
  }

  function openCart() {
    cartDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  window.openCart = openCart;

  $$('[data-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
  $('.cart-drawer__overlay')?.addEventListener('click', closeCart);

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function updateCount(count) {
    cartCountEls.forEach((el) => { el.textContent = count; });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!cartBody) return;

    if (cart.item_count === 0) {
      cartBody.innerHTML = '';
      cartEmpty?.classList.remove('hidden');
      cartFooter?.classList.add('hidden');
      return;
    }

    cartEmpty?.classList.add('hidden');
    cartFooter?.classList.remove('hidden');

    cartBody.innerHTML = cart.items.map((item) => {
      const variantBadge = item.variant_title && item.variant_title !== 'Default Title'
        ? `<span style="display:inline-block;margin-top:0.25rem;font-size:0.75rem;font-weight:600;background:var(--ink);color:var(--ink-foreground);padding:0.1rem 0.5rem;border-radius:999px">${item.variant_title}</span>`
        : '';
      return `
      <div class="cart-drawer__item" data-key="${item.key}">
        <img class="cart-drawer__item-img" src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">
        <div style="flex:1;min-width:0">
          <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:0.5rem">
            <div>
              <p style="font-weight:500;font-size:0.875rem;line-height:1.3">${item.product_title}</p>
              ${variantBadge}
            </div>
            <button type="button" data-remove="${item.key}" aria-label="Elimina" style="color:var(--muted-foreground)">x</button>
          </div>
          <p style="font-size:0.875rem;color:var(--muted-foreground);margin-top:0.5rem">${formatMoney(item.final_line_price)}</p>
          <div class="qty-control" style="margin-top:0.75rem">
            <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="Scade">-</button>
            <span>${item.quantity}</span>
            <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Creste">+</button>
          </div>
        </div>
      </div>`;
    }).join('');

    const subtotalEl = $('.cart-drawer__subtotal-value');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    cartBody.querySelectorAll('[data-remove]').forEach((btn) => {
      btn.addEventListener('click', () => changeQty(btn.dataset.remove, 0));
    });
    cartBody.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => changeQty(btn.dataset.qtyChange, parseInt(btn.dataset.qty, 10)));
    });
  }

  async function changeQty(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await fetchCart();
    renderCart(cart);
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!res.ok) {
      const err = await res.json();
      alert(err.description || 'Nu am putut adauga produsul in cos.');
      return;
    }
    const cart = await fetchCart();
    renderCart(cart);
    openCart();
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const variantId = form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
    if (variantId) await addToCart(variantId, qty);
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (variantId) await addToCart(variantId, 1);
  });

  fetchCart().then(renderCart).catch(() => {});

  /* Product gallery */
  const galleryMain = $('.product-gallery__main img');
  $$('.product-gallery__thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      const alt = thumb.dataset.alt || '';
      if (galleryMain && src) {
        galleryMain.src = src;
        if (srcset) {
          galleryMain.srcset = srcset;
        } else {
          galleryMain.removeAttribute('srcset');
          galleryMain.removeAttribute('sizes');
        }
        galleryMain.alt = alt;
      }
      $$('.product-gallery__thumb').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* Product tabs + Judge.me */
  let judgeMeSetupDone = false;
  let judgeMeSetupPending = false;

  const unlockJudgeMeWidgets = () => {
    $$('.jdgm-temp-hiding-style').forEach((el) => el.remove());
    $$('#product-reviews .jdgm-rev-widg, .product-reviews .jdgm-rev-widg, #judgeme_product_reviews .jdgm-rev-widg').forEach((widg) => {
      widg.style.removeProperty('display');
    });
    $('#judgeme_product_reviews')?.style.removeProperty('display');
  };

  const whenJudgeMeReady = (cb) => {
    const ready = () => window.jdgm?.$ && typeof window.jdgm.initializeWidgets === 'function';
    if (ready()) { cb(); return; }
    let attempts = 0;
    const poll = setInterval(() => {
      if (ready() || ++attempts > 100) {
        clearInterval(poll);
        if (ready()) cb();
      }
    }, 100);
  };

  const getJudgeMeReviewWidget = () => {
    const jq = window.jdgm?.$;
    if (!jq) return null;
    const $widget = jq('#judgeme_product_reviews, .product-reviews .jdgm-review-widget').first();
    return $widget?.length ? $widget : null;
  };

  const ensureJudgeMeFormStars = () => {
    const jdgm = window.jdgm;
    const jq = jdgm?.$;
    if (!jq) return;
    jq('.product-reviews .jdgm-form__rating').each(function () {
      const $rating = jq(this);
      if ($rating.children('.jdgm-star').length) return;
      if (typeof $rating.raty !== 'function') return;
      try { $rating.raty('destroy'); } catch (_) {}
      $rating.raty({ score: 0 });
      if (typeof jdgm._rtlStarsEnabled === 'function' && jdgm._rtlStarsEnabled()) {
        jdgm._applyRtlStarsOrder?.($rating);
        $rating.attr('dir', 'ltr');
      }
      $rating.find('.jdgm-star').attr({ role: 'button', tabindex: '0' });
    });
  };

  const watchJudgeMeFormOpen = () => {
    const root = $('.product-reviews');
    if (!root || !('MutationObserver' in window)) return;
    const observer = new MutationObserver(() => {
      if ($('.product-reviews .jdgm-form-wrapper')) ensureJudgeMeFormStars();
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  };

  const dedupeJudgeMeControls = () => {
    const root = $('.product-reviews');
    if (!root) return;
    $$('.product-reviews .jdgm-widget-actions-wrapper').forEach((wrapper, index) => {
      if (index > 0) wrapper.remove();
    });
    const writeLinks = $$('.product-reviews .jdgm-write-rev-link');
    const preferredWrite = writeLinks.find((link) => link.closest('.jdgm-widget-actions-wrapper, .jdgm-rev-widg__actions'));
    writeLinks.forEach((link) => { if (link === preferredWrite) return; link.remove(); });
    const forms = $$('.product-reviews .jdgm-form-wrapper');
    forms.forEach((form, index) => { if (index > 0) form.remove(); });
    const primaryForm = $('.product-reviews .jdgm-form-wrapper');
    const cancelLinks = $$('.product-reviews .jdgm-cancel-rev');
    let keptCancel = false;
    cancelLinks.forEach((link) => {
      if (primaryForm && !primaryForm.contains(link)) { link.remove(); return; }
      if (!keptCancel) { keptCancel = true; return; }
      link.remove();
    });
  };

  const setupJudgeMeReviews = () => {
    unlockJudgeMeWidgets();
    if (judgeMeSetupDone || judgeMeSetupPending) return;
    judgeMeSetupPending = true;
    whenJudgeMeReady(() => {
      if (judgeMeSetupDone) { judgeMeSetupPending = false; dedupeJudgeMeControls(); ensureJudgeMeFormStars(); return; }
      const jdgm = window.jdgm;
      const $widget = getJudgeMeReviewWidget();
      if (!$widget) { judgeMeSetupPending = false; return; }
      if ($widget.hasClass('jdgm--done-setup-widget')) {
        dedupeJudgeMeControls(); ensureJudgeMeFormStars();
        judgeMeSetupDone = true; judgeMeSetupPending = false; return;
      }
      const $scope = $widget.closest('.product-reviews, #product-reviews');
      jdgm.initializeWidgets($scope.length ? $scope : undefined);
      if (typeof jdgm.customize === 'function') jdgm.customize();
      dedupeJudgeMeControls(); ensureJudgeMeFormStars();
      judgeMeSetupDone = true; judgeMeSetupPending = false;
    });
  };

  document.addEventListener('click', (e) => {
    const link = e.target.closest?.('.jdgm-write-rev-link');
    if (!link?.closest('.product-reviews, #product-reviews, #judgeme_product_reviews')) return;
    if (link.getAttribute('href') === '#') e.preventDefault();
    setTimeout(ensureJudgeMeFormStars, 80);
    setTimeout(ensureJudgeMeFormStars, 400);
  }, true);

  document.addEventListener('jdgm.reviewSubmitted', () => {
    judgeMeSetupDone = false; judgeMeSetupPending = false;
    setTimeout(setupJudgeMeReviews, 600);
  });

  const activateProductTab = (tabName) => {
    const btn = $(`.product-tabs__btn[data-tab="${tabName}"]`);
    if (!btn) return false;
    $$('.product-tabs__btn').forEach((b) => b.classList.toggle('is-active', b === btn));
    $$('.product-tabs__panel').forEach((p) => p.classList.toggle('is-active', p.dataset.tab === tabName));
    return true;
  };

  $$('.product-tabs__btn').forEach((btn) => {
    btn.addEventListener('click', () => activateProductTab(btn.dataset.tab));
  });

  const reviewsSection = $('#product-reviews');
  if (reviewsSection) {
    watchJudgeMeFormOpen();
    const startInit = () => setupJudgeMeReviews();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => { if (entries.some((entry) => entry.isIntersecting)) { startInit(); observer.disconnect(); } },
        { rootMargin: '300px 0px' }
      );
      observer.observe(reviewsSection);
    } else {
      setTimeout(startInit, 300);
    }
    window.addEventListener('load', () => setTimeout(startInit, 50));
  }

  const scrollToReviews = () => {
    const target = $('#product-reviews');
    if (!target) return;
    setupJudgeMeReviews();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  $$('[data-scroll-to-reviews]').forEach((el) => {
    const go = () => scrollToReviews();
    el.addEventListener('click', go);
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
    });
  });

  /* Product description expand */
  $$('[data-description-toggle]').forEach((btn) => {
    const wrap = btn.closest('[data-product-description]');
    const body = wrap?.querySelector('[data-description-body]');
    const label = btn.querySelector('[data-description-toggle-label]');
    if (!body) return;
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      btn.setAttribute('aria-expanded', String(next));
      body.classList.toggle('is-collapsed', !next);
      if (label) label.textContent = next ? 'Vezi mai putin' : 'Vezi mai mult';
    });
  });

  /* Collection sort */
  const sortSelect = $('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
